import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, PostSignInResponse } from "@/types";

export const usePostSignIn = () => {
  return useQuery({
    queryKey: ["login"],
    queryFn: async () => {
      const path = "auth/login";
      const res = await guacHttpClient.get<
        PostSignInResponse,
        HttpResponse<PostSignInResponse>
      >(path);
      return res.data;
    },
  });
};
